module.exports = __webpack_public_path__ + "img/YunFeng Zhang.1e0872f2.jpg";